//{{-- ========================================================================================== --}}
//{{-- Scripts to save the document to the database                                               --}}
//{{-- ========================================================================================== --}}

//{{-- This puts all document data into docsArr, ready for sending to server to save --}}
window.prepDocuments = function(docArr, projstatus) {                                
    var docsArr = [];
    jQuery.each(docArr, function(index, value) {
        var dArr = {};
        dArr = fileToDocArr(value, projstatus);
        //docsArr.push(...dArr);                                                      //{{-- THE SPREAD SYNTAX (...) IS ES6, DOES NOT WORK ON IE --}}
        for (var i=0; i < dArr.length; i++) {
            docsArr.push(dArr[i]);
        }
    });
    return docsArr;
}

window.fileToDocArr = function(row, projstatus) {
    //{{-- Prepares data from single row in the datatable to save to the database --}}
    //{{-- Builds an array containing a single document, in all its language pair variations --}}
    //{{-- ... each array element has the base doc information and one language pair --}}
    var docArr = [];
    //{{-- Get the BASE DOCUMENT data first --}}
    var docBaseArr = {
                docstatus_id        : projstatus,
                doctype_id          : row.doctype,
                videotype_id        : row.videotype,
                fromlanguage_id     : row.langfrom,
                file_name           : row.filename,
                file_name_original  : row.filenameOriginal,
                original_disk       : row.originalDisk,
                characters          : row.characters,
                words               : row.words,
                minutes             : row.minutes,
                date_received       : dateToMySQL(new Date()),
                date_requested      : datetimeToMySQL(row.duedate, row.duetime),
                rush_fee_mult       : 1,
                tier_id             : row.tier,                    
                original_path       : row.uploadedPath, 
                file_size           : row.file_size,                
                amount_site         : 0,                //{{-- will be updated below --}}
                jobtype_id          : 1,                //{{-- will be updated below --}}                                    
    };
    //{{-- Now deal with multiple "to languages" - AT THIS POINT, THERE MUST BE AT LEAST ONE --}}
    //{{-- Each "to language" generates one new record in the Documents table - and therefore one element in docArr --}}
    jQuery.each(row.langto, function(index, tolanguage_id) {
        //{{-- make sure langto value is not empty --}}
        if(tolanguage_id) {
            //{{-- First get the date-specific fields - remember that langtoPrices has this format: [[priceT0,priceT1,priceT2],[priceT0,priceT1,priceT2]}...] - indexed by langto id --}}
            //{{-- Objects are assigned by reference, so we use the JSON hack to break the reference... it appears Javascript doesn't have an elegant solution for this... --}}
            docBaseArr.tolanguage_id = tolanguage_id;
            docBaseArr.amount_site   = row.langtoPrices[tolanguage_id][row.tier] + "";      //{{-- gets the right langto price and convert to string --}}
            docBaseArr.jobtype_id    = (row.langfrom === tolanguage_id) ? 2 : 1;            //{{-- if both languages are the same, it's a revision (2), else, a translation (1); --}}
            var tempArr= {};
            tempArr = JSON.parse(JSON.stringify(docBaseArr));
            docArr.push(tempArr);                                                           //{{-- push the complete docBaseArr instance into docArr --}}
        }
    });
    //{{-- Return the array with the documents data --}}
    return docArr;
}
